export const ICON_STROKE_WIDTH="10px";
